import { render, staticRenderFns } from "./formIdNumber.vue?vue&type=template&id=14d06f26&scoped=true"
import script from "./formIdNumber.vue?vue&type=script&lang=js"
export * from "./formIdNumber.vue?vue&type=script&lang=js"
import style0 from "./formIdNumber.vue?vue&type=style&index=0&id=14d06f26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d06f26",
  null
  
)

export default component.exports